import { useState } from 'react';
import { Button } from 'react-aria-components';
import { Icon } from '@platform/components';

const stripHtml = (html: string) =>
  html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

export const OriginalProjectDescription = ({ description }: { description?: string | null }) => {
  const [isOpen, setIsOpen] = useState(false);

  const text = stripHtml(description ?? '');

  if (!text) return null;

  return (
    <div className='overflow-hidden rounded-xl border border-gray-100 bg-gray-50'>
      <Button
        className='flex w-full cursor-pointer items-center justify-between gap-3 px-5 py-4 outline-none'
        onPress={() => setIsOpen((prev) => !prev)}
      >
        <span className="text-sm font-medium leading-5 text-gray-700">
          Original Project Description
        </span>
        <Icon
          type={isOpen ? 'chevron-up' : 'chevron-down'}
          size='20'
          additionalClassNames='stroke-gray-400 shrink-0'
        />
      </Button>
      <div className='px-5 pb-4'>
        <p className={`text-sm font-normal leading-5 text-gray-700 ${!isOpen ? 'line-clamp-2' : ''}`}>
          {text}
        </p>
      </div>
    </div>
  );
};
